import React, { useState } from 'react'

import { Container, Content, ContentTypography, ContainerOver } from './styles'
import { TITLES_HEADER } from 'src/constants/strings'

interface ITableViewProps {
    handleTableView: (title: string) => void
}

const Index = ({ handleTableView }: ITableViewProps) => {
    const [titleActive, setTitleActive] = useState<string>('Contact')
    const handleChangeTitleActive = (title: string) => {
        handleTableView(title)
        setTitleActive(title)
    }
    return (
        <ContainerOver>
            <Container>
                {TITLES_HEADER.map((el) => {
                    return (
                        <Content
                            key={`navItem-${el.title}`}
                            active={el.title === titleActive}
                            onClick={() => {
                                handleChangeTitleActive(el.title)
                            }}
                        >
                            <ContentTypography
                                variant={'h2'}
                                fontSize={[
                                    'xsmall',
                                    'xsmall',
                                    'xmedium',
                                    'xmedium',
                                ]}
                                fontWeight={500}
                            >
                                {el.title}
                            </ContentTypography>
                        </Content>
                    )
                })}
            </Container>
        </ContainerOver>
    )
}
export default Index
